import React, { createContext, useContext, useEffect, useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'

const VitalityExerciseContext = createContext()

const useVitalityExercise = () => {
  return useContext(VitalityExerciseContext)
}

const VitalityExerciseProvider = ({ children }) => {
  const { t } = useTranslation('vitality')
  const { setContinueButtonDisabled, trackContent, getResponse } = useExercise()
  const pageOneTranslations = t('pages.0')
  const pageTwoTranslations = t('pages.1')
  const pointsOfVitality = pageOneTranslations.points_of_vitality
  const initialPoints =
    trackContent[0]?.rankedPoints ||
    pointsOfVitality.map((point) => ({
      ...point,
      rank: point.rank ? parseInt(point.rank) : null,
    }))
  const [rankedPoints, setRankedPoints] = useState(initialPoints)

  useEffect(() => {
    setContinueButtonDisabled(rankedPoints.some((point) => point.rank === null))
  }, [rankedPoints, setContinueButtonDisabled])

  const value = {
    getResponse,
    trackContent,
    rankedPoints,
    pointsOfVitality,
    pageOneTranslations,
    setRankedPoints,
    pageTwoTranslations,
  }

  return (
    <VitalityExerciseContext.Provider value={value}>
      {children}
    </VitalityExerciseContext.Provider>
  )
}

export { VitalityExerciseProvider, useVitalityExercise }
